import React, { useEffect, useState } from "react";
import { EnterpriseGrid, Organization } from "@pollyslack/hub/src/types";
import { Spinner } from "reactstrap";
import { listOrgs } from "../../../services/api/Enterprise";
import { OrganizationsTable } from "../../../pages/Organizations/components/OrganizationsTable";
import NoDataMessage from "../../../common/NoDataMessage";

type OrganizationsTabProps = {
  grid: EnterpriseGrid;
  reload: () => void;
};

export const OrganizationsTab: React.FunctionComponent<
  OrganizationsTabProps
> = (props: OrganizationsTabProps) => {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function loadOrganizations() {
      setIsLoading(true);
      try {
        const orgs = await listOrgs({ search: props.grid.slackEnterpriseId });
        setOrganizations(orgs);
      } catch (e) {
        console.error("Error loading organizations:", e);
        alert("Error loading organizations: " + e);
      } finally {
        setIsLoading(false);
      }
    }
    loadOrganizations();
  }, [props.grid.slackEnterpriseId]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center pt-5">
        <Spinner style={{ width: "3rem", height: "3rem" }} />
        <div className="pl-2" style={{ fontSize: "2rem" }}>
          Loading...
        </div>
      </div>
    );
  }

  if (!organizations || organizations.length === 0) {
    return <NoDataMessage componentName="organizations in this grid" />;
  }

  return (
    <div>
      <h3 className="mb-3">Organizations in this Enterprise Grid</h3>
      <OrganizationsTable organizations={organizations} />
    </div>
  );
};
